import { type OpenApiSchemaDiscount, type OpenApiSchemaPromocodeGroup } from '#shared/api/schema';
import { PROMOACTIONS_MODE } from '../constants';
import { type PromoactionCollectionFields, type PromoactionModel } from '../types';

// Поля появятся в сгенерированной схеме после обновления backend-контракта.
type DiscountWithCollectionFields = OpenApiSchemaDiscount & Partial<PromoactionCollectionFields>;

export const mapDiscountToPromoaction = (discount: DiscountWithCollectionFields): PromoactionModel => {
    const isPercent = discount.discount_value.type === 'PERCENT';

    const { category_ids, collection_ids, productListID } = discount.discount_objects || {};

    let applicabilityType: OpenApiSchemaPromocodeGroup['applicability_type'] =
        discount.discount_applicability === 'ALL_PRODUCTS' ? 'ALL_PRODUCTS' : 'PRODUCT_LIST';

    if (category_ids?.length || collection_ids?.length) {
        applicabilityType = 'CATEGORIES_AND_COLLECTIONS';
    } else if (productListID) {
        applicabilityType = 'PRODUCT_LIST';
    }

    let value_percent = '';
    let value_fixed = '';

    if (isPercent) {
        value_percent = discount.discount_value.value;
    } else {
        value_fixed = discount.discount_value.value;
    }

    return {
        id: discount.id,
        title: discount.title,
        kind: discount.kind,
        ...(discount.promo_offer_id ? { promoOfferId: discount.promo_offer_id } : {}),
        mode: {
            mode: PROMOACTIONS_MODE.automatic,
            promocodeGroupType: 'single',
            promocodeGroupId: '',
        },
        discount: {
            type: isPercent ? 'percent' : 'fixed_amount',
            value_percent,
            value_fixed,
            minimum_order_amount: '',
            max_discount_amount: '',
            effect_direction: discount.effect_direction,
            price_index_sources: discount.price_index_sources,
        },
        validity: {
            isOneTimeUse: 'false',
            isFirstOrderOnly: 'false',
            maxUsageLimit: 'false',
            isPermanent: !discount.discount_dates.end_date,
            validFrom: discount.discount_dates.start_date,
            validUntil: discount.discount_dates.end_date || '',
        },
        applicability: {
            type: applicabilityType,
            appliedProductListId: productListID || '',
            appliedCategoryIds: category_ids || [],
            appliedCollectionIds: collection_ids || [],
        },
        badge: discount.badge
            ? {
                  id: discount.badge.id,
                  label: discount.badge.label,
                  color: discount.badge.color,
                  tooltip: discount.badge.tooltip,
              }
            : null,
        autoCollectionId: discount.collection_id ?? '',
        autoCollectionTitle: discount.collection_title ?? '',
        autoCollectionDescription: discount.collection_description ?? '',
        showAutoCollectionInFeed: Boolean(discount.show_auto_collection_in_feed),
        showInPdp: 'false',
        meta: {
            type: 'on_products',
            usageCount: 0,
            deactivated: !discount.is_active,
            status: discount.is_currently_active ? 'active' : 'inactive',
            createdAt: discount.created_at,
            updatedAt: discount.updated_at,
            statusColor: discount?.has_import_errors ? 'error' : undefined,
        },
    };
};
